import 'reflect-metadata';
import '@getaccept/lib-shared/src/polyfills';
import Vue from 'vue';
import vTooltip from 'v-tooltip';
import VueSignaturePad from 'vue-signature-pad';
import LibUi from '@getaccept/lib-ui';
import { PiniaVuePlugin, createPinia } from 'pinia';
import Router from 'vue-router';
import AppWrapper from './AppWrapper.vue';
import router from './router';
import i18n from './lang';
import './init';
import '@getaccept/lib-shared/src/bugsnag';
import 'focus-visible';
import './css/global.scss';

Vue.use(PiniaVuePlugin);
Vue.config.productionTip = false;
Vue.use(vTooltip, { defaultHtml: false });
Vue.use(LibUi);
Vue.use(VueSignaturePad);
Vue.use(Router);

const pinia = createPinia();

new Vue({
  router,
  pinia,
  i18n,
  render: h => h(AppWrapper),
}).$mount('#signing-page');

if (process.env.NODE_ENV === 'development') {
  console.log(`%c🚀 Running "signing-site" locally 🚀`, 'font-size: 1rem; line-height: 2rem;');
}
